import { DateTime } from "luxon";

export const formatIsoString = (isoString, format) => {
  const date = DateTime.fromISO(isoString);
  return date.toFormat(format);
};
